import React from 'react';
import axios from "../../../containers/api";
import {Link, NavLink} from "react-router-dom";
import DatePicker, { utils } from "react-modern-calendar-datepicker";
import {Table} from "../../../components/table/Table";
import Config from "../../../constants/config";
import {Colxx, Separator} from "../../../components/common/CustomBootstrap";
import {
    Badge, Button, Card, CardBody, CardHeader, Collapse, FormGroup, Label, Nav, NavItem, Row, TabContent, TabPane, ModalBody,
    Modal,
    ModalHeader, Input, CustomInput, ModalFooter, CardTitle,
} from "reactstrap";
 
import {getkalas, showCatchError, convertDate, toCurrency,   toEnglishNumbers} from "../../../helpers/Utils";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

class Cargos extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            activeTab: "1",
            optionsMenu: null,
            collapse: true,
            fromDate: utils('fa').getToday(),
            toDate: utils('fa').getToday(),
            Cargos: [],
         
            customers: [],
            kalas: [],
            senders: [],
            receivers: [],
            
            selectedkalas: [],
            CargosSearchResult: [],
            CargoId: null,
            mode: 1,
            TransportationCompanyList:[],
            TransportationCompany:null,
             CargoStatus: [
                { value: 0, text: 'فعال' },
                { value: 1, text: 'غیرفعال' },
                { value: 2, text: 'همه' }
            ],
            selectedCargoStatus: { value: 2, text: 'همه' },
            FinishCargoModal: false,
            IsLoadHall: false,
            FinishDesc: "",
        }
    }

    componentDidMount() {
      
        if (this.state.kalas.length === 0) {
            try {
                this.getkalasApi().then(r => console.log(r));
            } catch (err) {
                console.log(err);
            }
        }
        
        
        if (this.props.memberType.role === 'ProductOwnerAdmin' || this.props.memberType.role === 'Driver' ||this.props.memberType.role === 'AdminSupport' || this.props.memberType.role === 'Admin' || this.props.memberType.role === 'Organization' || this.props.memberType.role === 'DriversAssociation' || this.props.memberType.role === 'AssociationTransportCompanies') {
            this.GetAllTransportationCompany();
            this.GetAllCustomer();
        }
        else
            this.GetCustomerByTransportationCompanyId();
       
            this.SearchCargo();
        window.scrollTo(0, 0);
    }

    //checkPermission = () => {
    //    axios.get('api/ClientApi/HasAccessTo?permissionName=Cargo_Manage')
    //        .then((res) => {
    //            if (res.data) {
    //                if (this.state.kalas.length === 0) {
    //                    try {
    //                        this.getkalasApi().then(r => console.log(r));
    //                    } catch (err) {
    //                        console.log(err);
    //                    }
    //                }

                    
    //                this.GetCustomerByTransportationCompanyId();
                    
    //            } else {
    //                this.props.history.push('/error404')
    //            }
    //        })
    //        .catch((error) => {
    //            this.props.hideSpinner();
    //            console.log(error.response);
    //            this.props.showAlert(showCatchError(error), "error");
    //        });
    //};
    
    GetCustomerByTransportationCompanyId = () => {
        axios.get('/api/v1/Customer/GetCustomerByTransportationCompanyId')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ customers: res.data.data });
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    GetAllCustomer = () => {
        axios.get('/api/v1/Customer/GetAllCustomer')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ customers: res.data.data });
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    
    GetAllTransportationCompany = () => {
        let api = '';
        if ( this.props.memberType.role === 'Organization' || this.props.memberType.role === 'DriversAssociation' || this.props.memberType.role === 'AssociationTransportCompanies')
            api = 'TransportationCompanyUser/GetByUserId'
        else
            api ='TransportationCompany/GetAll'
        //axios.get('/api/v1/TransportationCompanyUser/GetByUserId')
        axios.get('/api/v1/' + api)
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ TransportationCompanyList: res.data.data });
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    
     

    async getkalasApi() {
        try {
            await getkalas()
                .then((res) => this.setState({kalas: res.data}) );
        } catch (err) {
            this.props.showAlert(showCatchError(err), "error");
        }
    }

    

    SearchCargo = () => {
        let searchModel = {
            FromDate: convertDate(this.state.fromDate),
            ToDate: convertDate(this.state.toDate),
            ReceiverCustomerId: [],
            SenderCustomerId: [], 
            KalaId: [],
            CargoStatus: toEnglishNumbers(this.state.selectedCargoStatus.value),
            TransportationCompanyId: null,
        };
        if (this.props.memberType.role === 'AdminSupport' || this.props.memberType.role === 'Admin' || this.props.memberType.role === 'Organization' || this.props.memberType.role === 'DriversAssociation' || this.props.memberType.role === 'AssociationTransportCompanies')
            searchModel.TransportationCompanyId= (this.state.TransportationCompany !== null &&  this.state.TransportationCompany !== undefined)?this.state.TransportationCompany.transportationCompanyId:null
        if (this.state.receivers.length !== 0) {
            this.state.receivers.map((receiver) =>
                searchModel.ReceiverCustomerId.push(receiver.id)
            )
        }
        if (this.state.senders.length !== 0) {
            this.state.senders.map((sender) =>
                searchModel.SenderCustomerId.push(sender.id)
            )
        }
        
        if (this.state.selectedkalas.length !== 0) {
            this.state.selectedkalas.map((selectedkala) =>
                searchModel.KalaId.push(selectedkala.id)
            )
        }

        this.props.showSpinner();
        axios.post('/api/v1/Cargo/SearchCargo', searchModel)
            .then((res) => {
                this.props.hideSpinner();
                console.log(res.data.data)
                this.setState({CargosSearchResult: res.data.data, searchFilters: false});
                if (this.state.CargosSearchResult.length === 0) {
                    this.props.showAlert("موردی یافت نشد", "warning");
                } else {
                    this.props.showAlert(this.state.CargosSearchResult.length.toString()+ " مورد یافت شد", "success");
                }

            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            })
    };

    clearSearch = () => {
        
        this.setState({
            receivers: [],
            senders: [],
            selectedkalas: [], 
            selectedCargoStatus: { value: 2, text: 'همه' },
            fromDate: utils('fa').getToday(),
            toDate: utils('fa').getToday(),
        } )
        if (this.props.memberType.role === 'AdminSupport' || this.props.memberType.role === 'Admin' || this.props.memberType.role === 'Organization' || this.props.memberType.role === 'DriversAssociation' || this.props.memberType.role === 'AssociationTransportCompanies') {
            this.setState({
                TransportationCompany: null,
            })
        }

    };

    Redirect = (AccordNumber,CargoId) => {
        const location = {
            pathname: '/Cargos/Detail/' + CargoId + '/' + AccordNumber
        }
        this.props.history.push(location);
    }

    selectHandleChange = (event, value, name) => {
        this.setState({[name]: value });
    };

    OptionsMenuClick = (event, id) => {
        this.setState({ [id]: event.currentTarget, optionsMenu: id });
    };
    OptionsMenuClose = (id) => {
        this.setState({ [id]: null, optionsMenu: null });
    };
    toggleTab = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({activeTab: tab});
        }
    }
    FinishCargo = () => {
        this.props.closeSweetAlert();

        let cancelPriority = this.props.memberType.role === 'Admin' ? this.state.IsCancelPriority : null;
        if (this.state.FinishDesc === null || this.state.FinishDesc === undefined || this.state.FinishDesc === "" || this.state.FinishDesc === '') {
            this.props.showAlert('وارد كردن علت اتمام بار الزامی میباشد!', 'error');
            return;
        }
        const model = { 
            Id: this.state.CargoId,
            IsCancelPriority:cancelPriority,
            Desc: toEnglishNumbers(this.state.FinishDesc), 
        };
        this.props.showSpinner();
        axios.post('/api/v1/Cargo/FinishCargo', model) 
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data.code == 1) {
                    this.props.showAlert(res.data.data.message, "success");
                    this.SearchCargo();
                }
                else
                    this.props.showAlert(res.data.data.message, "error");
               
                
               
            })
            .catch((error) => {
                console.log(error.response);
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            })
    };
    ActiveCargo = (id) => {
        this.props.closeSweetAlert();
        this.props.showSpinner();
        axios.post('api/v1/Cargo/ActiveCargo?cargoId=' + id, null)
            .then(() => {
                this.props.showAlert("بار با موفقیت تایید شد", 'success');
                this.SearchCargo();
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
    closeModal = (modalName) => {
       
        this.setState({ [modalName]: false });
    };
    Reserve = (cargo) => {
        let Id = parseInt(this.props.memberType.clientId);
        const model = {
            CargoId: cargo.id,
            ReserveType: true,
            DriverId: Id,
            IsWeb:true
        };
        this.props.closeSweetAlert();
         this.props.showSpinner();

        axios.post('api/v1/DriverReserve/AddDriverReserve', model)
            .then((res) => {
                
                console.log(res.data.data)
                 
                if (res.data.statusCode === 200) {
                    this.props.hideSpinner();
                    this.props.showAlert(res.data.data, "success");
                    this.SearchCargo();
                }
                else {
                    this.props.showAlert(res.data.errors[0], "error");
                    this.props.hideSpinner();
                   
                }
                 
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
    render() {
        return (
            <>
                <Row>
                    <Colxx xxs="12">
                        <h3>لیست بارهای اعلام شده</h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>

                <Row>
                    <Colxx xxs="12">
                        <Card >
                            <CardBody>
                                    <Row>
                                        <Colxx sm="12">
                                            <CardBody>
                                            <CardTitle>جستجو</CardTitle> 
                                                   <div className="p-4 pt-5 border d-flex flex-column">
                                                        <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap">
                                                            <FormGroup className="w-md-25 w-100 px-1">
                                                                <Label>از تاریخ</Label>
                                                                <DatePicker
                                                                    value={this.state.fromDate}
                                                                    onChange={(newDate) => this.setState({fromDate: newDate})}
                                                                    inputPlaceholder="لطفا یک تاریخ انتخاب کنید"
                                                                    shouldHighlightWeekends
                                                                    inputClassName="form-control"
                                                                    locale="fa"
                                                                    calendarClassName="calendar"
                                                                    colorPrimary={Config.color}
                                                                    calendarPopperPosition={'bottom'}
                                                                />
                                                            </FormGroup>

                                                            <FormGroup className="w-md-25 w-100 px-1">
                                                                <Label>تا تاریخ</Label>
                                                                <DatePicker
                                                                    value={this.state.toDate}
                                                                    onChange={(newDate) => this.setState({toDate: newDate})}
                                                                    inputPlaceholder="لطفا یک تاریخ انتخاب کنید"
                                                                    shouldHighlightWeekends
                                                                    inputClassName="form-control"
                                                                    locale="fa"
                                                                    calendarClassName="calendar"
                                                                    colorPrimary={Config.color}
                                                                    calendarPopperPosition={'bottom'}
                                                                />
                                                            </FormGroup>

                                                            <FormGroup className="w-md-25 w-100 px-1">
                                                                <Label>نوع محموله‌ها</Label>
                                                                <Autocomplete
                                                                    multiple
                                                                    clearText={"حذف"}
                                                                    closeText={"بستن"}
                                                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                                                    openText={"باز کردن"}
                                                                    className="react-select__control"
                                                                    id="selectedkalas"
                                                                    options={this.state.kalas}
                                                                    value={this.state.selectedkalas}
                                                                    getOptionLabel={(option) => option.kalaDesc}
                                                                    onChange={(e, v) => this.selectHandleChange(e, v, "selectedkalas")}
                                                                    renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                                                                />
                                                            </FormGroup>

                                                        </div>
                                                            <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap">
                                                    {this.props.memberType.role !== 'Driver' &&
                                                        <FormGroup className="w-md-25 w-100 px-1">
                                                        <Label>فرستنده‌ها</Label>
                                                        <Autocomplete
                                                            multiple
                                                            clearText={"حذف"}
                                                            closeText={"بستن"}
                                                            noOptionsText={"در حال دریافت اطلاعات.."}
                                                            openText={"باز کردن"}
                                                            className="react-select__control"
                                                            id="senders"
                                                            options={this.state.customers}
                                                            getOptionLabel={(option) => option.customerFullName + ' (' + option.meliCode + ')'}
                                                            onChange={(e, v) => this.selectHandleChange(e, v, "senders")}
                                                            value={this.state.senders}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    // className="form-control"
                                                                    variant="standard"
                                                                    placeholder=""
                                                                    inputProps={{ ...params.inputProps, style: { fontFamily: "IRANSans" } }}
                                                                />
                                                            )}
                                                        />
                                                    </FormGroup>
                                                    }
                                                    {this.props.memberType.role !== 'Driver' &&
                                                        <FormGroup className="w-md-25 w-100 px-1">
                                                            <Label>گیرنده‌ها</Label>
                                                            <Autocomplete
                                                                multiple
                                                                clearText={"حذف"}
                                                                closeText={"بستن"}
                                                                noOptionsText={"در حال دریافت اطلاعات.."}
                                                                openText={"باز کردن"}
                                                                className="react-select__control"
                                                                id="receivers"
                                                                options={this.state.customers}
                                                                getOptionLabel={(option) => option.customerFullName + ' (' + option.meliCode + ')'}
                                                                onChange={(e, v) => this.selectHandleChange(e, v, "receivers")}
                                                                value={this.state.receivers}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        // className="form-control"
                                                                        variant="standard"
                                                                        placeholder=""
                                                                        inputProps={{ ...params.inputProps, style: { fontFamily: "IRANSans" } }}
                                                                    />
                                                                )}
                                                            />
                                                        </FormGroup>
                                                    }
                                                    000
                                                        <FormGroup className="w-md-25 w-100 px-1">
                                                            <Label>وضعیت</Label>
                                                            <Autocomplete
                                                                disableClearable
                                                                clearText={"حذف"}
                                                                closeText={"بستن"}
                                                                noOptionsText={"در حال دریافت اطلاعات.."}
                                                                openText={"باز کردن"}
                                                                className="react-select__control"
                                                                id="selectedCargoStatus"
                                                                options={this.state.CargoStatus}
                                                                getOptionLabel={(option) => option.text}
                                                                value={this.state.selectedCargoStatus}
                                                                onChange={(e, v) => this.selectHandleChange(e, v, "selectedCargoStatus")}
                                                                renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                                            />
                                                        </FormGroup>
                                                    }
                                                        </div>
                                                        {(this.props.memberType.role === 'AdminSupport' || this.props.memberType.role === 'Admin' || this.props.memberType.role === 'Organization' || this.props.memberType.role === 'DriversAssociation' || this.props.memberType.role === 'AssociationTransportCompanies') &&
                                                            <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap">
                                                                <FormGroup className="w-md-30 w-100 px-1">
                                                                    <Label>شركت های حمل و نقل</Label>
                                                                    <Autocomplete
                                                                        clearText={"حذف"}
                                                                        closeText={"بستن"}
                                                                        noOptionsText={"در حال دریافت اطلاعات.."}
                                                                        openText={"باز کردن"}
                                                                        className="react-select__control"
                                                                        id="TransportationCompany"
                                                                        options={this.state.TransportationCompanyList}
                                                                        getOptionLabel={(option) => option.transportationCompanyName}
                                                                        value={this.state.TransportationCompany}
                                                                        onChange={(e, v) => this.selectHandleChange(e, v, "TransportationCompany")}
                                                                        renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                                                    />
                                                                </FormGroup>
                                                            </div>
                                                        }
                                                        <div className="d-flex mt-2 justify-content-center">
                                                            <FormGroup className="text-center">
                                                                <Button color="primary" className="btn-lg mx-2" onClick={this.SearchCargo}>
                                                                    جستجو
                                                                </Button>
                                                            </FormGroup>
                                                            <FormGroup className="text-center">
                                                                <Button color="primary" className="btn-lg mx-2" onClick={this.clearSearch}>
                                                                    پاک کردن
                                                                </Button>
                                                            </FormGroup>
                                                        </div>
                                                    </div>
                                                <Table
                                                    tableHeaders={[
                                                        "شناسه",
                                                        "وضعیت بار",
                                                        " رزرو بار",
                                                       // "شركت حمل و نقل",
                                                        "مبدا",
                                                        "مقصد",
                                                        "تعداد",
                                                        "وزن بار",
                                                        "کل کرایه", 
                                                        "نوع محموله",
                                                        "نوع ماشین", 
                                                        "تاریخ",
                                                        "ساعت",
                                                        "عملیات",
                                                      //  "تایید اعلام بار",
                                                      // "اتمام بار",
                                                       
                                                      
                                                        
                                                    ]}

                                                    tableRow={this.state.CargosSearchResult}

                                                    tableData={[
                                                        Cargo => {
                                                            return Cargo.id;
                                                        },
                                                        Cargo => {
                                                            
                                                                switch (Cargo.cargoStatus) {
                                                                    case -1:
                                                                        return <Badge color="outline-success" pill>در انتظار تاید شرکت</Badge>
                                                                    case 0:
                                                                        return <Badge color="outline-success" pill>در حال ارسال</Badge>
                                                                    case 1:
                                                                        return <Badge color="outline-warning" pill>اتمام بار</Badge>
                                                                        case 4:
                                                                        return <Badge color="outline-warning" pill>در انتظار تایید صاحب کالا</Badge>
                                                                }
                                                           
                                                        },
                                                        Cargo => {
                                                            if (Cargo.cargoStatus === 0 && this.props.memberType.role === 'Driver') {
                                                                return (
                                                                    <Button outline color="success" className="mx-3 my-md-0 my-1"
                                                                        onClick={() => this.props.showSweetAlert("آیا این بار رزرو شود؟", "", "success", () => this.Reserve(Cargo))}>
                                                                      رزرو بار
                                                                    </Button>


                                                                )
                                                            }
                                                            else {
                                                                return (
                                                                    ""
                                                                )
                                                            }
                                                            
                                                        },
                                                        // Cargo => {
                                                        //     return Cargo.transportationCompanyName !== null && Cargo.transportationCompanyName;
                                                        // },
                                                        Cargo => {
                                                            return Cargo.cargoSource;
                                                        },
                                                        Cargo => {
                                                            return Cargo.cargoDestination;
                                                        },
                                                        Cargo => {
                                                            return Cargo.freighterNumber;
                                                        },
                                                        Cargo => {
                                                            return Cargo.kalaWeight;
                                                        },
                                                        Cargo => {
                                                            return (Cargo.cargoRent !== null && Cargo.cargoRent !== "") ? toCurrency(Cargo.cargoRent) : null;
                                                        },
                                                        
                                                        Cargo => {
                                                            return Cargo.kalaDesc;
                                                        },
                                                        Cargo => {
                                                            return Cargo.loaderTypeNames;
                                                        },
                                                        Cargo => {
                                                            return Cargo.cargoDate;
                                                        },
                                                        Cargo => {
                                                            return Cargo.cargoTime;
                                                        },

                                                        Cargo => {
                                                            //if (this.props.memberType.role !== 'AdminSupport' && this.props.memberType.role !== 'Admin' && this.props.memberType.role !== 'Organization' && this.props.memberType.role !== 'DriversAssociation' && this.props.memberType.role !== 'AssociationTransportCompanies' && this.props.memberType.role !== 'Driver' && this.props.memberType.role !== 'ProductOwnerAdmin') { 
                                                            return (
                                                                <>
                                                                <Button
                                                        outline color="primary" size="sm"
                                                        aria-controls={"menu-" + Cargo.id}
                                                        aria-haspopup="true"
                                                        aria-expanded={this.state.optionsMenu === Cargo.id ? 'true' : undefined}
                                                        onClick={(event) => this.OptionsMenuClick(event, Cargo.id)}
                                                    >
                                                        بیشتر
                                                    </Button>
                                                    <Menu
                                                    id={"menu-" + Cargo.id}
                                                    MenuListProps={{'aria-labelledby': 'fade-button',}}
                                                    anchorEl={this.state[Cargo.id]}
                                                    open={this.state.optionsMenu === Cargo.id}
                                                    onClose={() => this.OptionsMenuClose(Cargo.id)}
                                                >
                                                    <MenuItem
                                                    component={Link}
                                                    to={`/EditCargo/${Cargo.id}`}
                                                   // onClick={handleMenuClose}
                                                    >
                                                       ویرایش 
                                                    </MenuItem>
                                                   {this.props.memberType.role === 'TransportationCompanyAdmin' && (
                    <MenuItem
                        onClick={() =>
                            this.props.showSweetAlert(
                                "آیا این بار تایید شود؟",
                                "",
                                "success",
                                () => this.ActiveCargo(Cargo.id)
                            )
                        }
                    >
                        تایید اعلام بار
                    </MenuItem>
                )}

                                                    <MenuItem onClick={() => this.setState({ FinishCargoModal: true, FinishDesc: "", IsCancelPriority: false, CargoId: Cargo.id, IsLoadHall: Cargo.isLoadHall })}>
                                                                    اعلام اتمام بار
                                                    </MenuItem>
                                                </Menu>
                                                               </>
                               
                                                            )
                                                       // }
                                                        },
                                                        // Cargo => {
                                                        //     if (Cargo.cargoStatus === -1 && this.props.memberType.role === 'Admin' ) {
                                                        //         return (
                                                        //             <Button outline color="success" className="mx-3 my-md-0 my-1"
                                                        //                 onClick={() => this.props.showSweetAlert("آیا این بار تایید شود؟", "", "success", () => this.ActiveCargo(Cargo.id))}>
                                                        //                 تایید اعلام بار
                                                        //             </Button>


                                                        //         )
                                                        //     }
                                                        //     else{
                                                        //         return (
                                                        //            ""
                                                        //         )
                                                        //     }
                                                         
                                                        // },
                                                        // Cargo => {
                                                        //     if ((Cargo.cargoStatus === 0 || Cargo.cargoStatus === -1) && this.props.memberType.role !== 'Organization' && this.props.memberType.role !== 'DriversAssociation' && this.props.memberType.role !== 'AssociationTransportCompanies' && this.props.memberType.role !== 'Driver' && this.props.memberType.role !== 'ProductOwnerAdmin') {
                                                        //         return (
                                                        //             <Button outline color="success" className="mx-3 my-md-0 my-1"
                                                        //                 onClick={() => this.setState({ FinishCargoModal: true, FinishDesc: "", IsCancelPriority: false, CargoId: Cargo.id, IsLoadHall: Cargo.isLoadHall })}>
                                                        //                 اعلام اتمام بار
                                                        //             </Button>


                                                        //         )
                                                        //     }
                                                        //     else{
                                                        //         return (
                                                        //            Cargo.finishDate +"-"+Cargo.finishTime
                                                        //         )
                                                        //     }

                                                        // },
                                                         
                                                    ]}
                                                />
                                            </CardBody>
                                        </Colxx>
                                    </Row>
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>
                <Modal isOpen={this.state.FinishCargoModal} toggle={() => this.closeModal("FinishCargoModal")} size="xlg">
                    <ModalHeader toggle={() => this.closeModal("FinishCargoModal")}>
                        اتمام بار
                    </ModalHeader>
                    <ModalBody>
                        <div className="d-flex flex-md-row flex-column w-100 justify-content-center">
                            <FormGroup className="w-md-50 w-100 mx-1">
                                <Label>علت اتمام بار</Label>
                                <Input value={this.state.FinishDesc} onChange={(e) => this.setState({ FinishDesc: e.target.value })} />
                            </FormGroup>

                            
                                
                           
                            
                        </div>
                        {this.props.memberType.role === 'Admin' && this.state.IsLoadHall===true &&
                        <div className="d-flex flex-md-row flex-column w-100 justify-content-center">
                          
                                <FormGroup className="w-md-50 w-100 mx-1">
                                    <CustomInput
                                        checked={this.state.IsCancelPriority === true}
                                        onClick={() => this.setState({ IsCancelPriority: !this.state.IsCancelPriority })}
                                        type="checkbox"
                                        label="كنسل كردن اولويت‌های فعال"
                                        id="IsCancelPriority"
                                    />
                                </FormGroup>
                                
                            
                        </div>
                        }

                        <div className="d-flex mb-2 mt-4 justify-content-center align-items-center">
                            <Button color="primary" className="btn-lg mx-2"
                                onClick={() => this.props.showSweetAlert("اتمام بار انجام شود؟", "", "success", this.FinishCargo)}>
                                اتمام بار
                            </Button>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.closeModal("FinishCargoModal")}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}

export default Cargos;